import { keyMirror } from 'utils/keyMirror';

export const ActionTypes = keyMirror(
  {
    EXPORT: null,
  },
  'ExportWindow',
);
